import { css } from '@eti/styles';
import { SEAT_MAP_CARD_MAX_WIDTH } from '../constants/modal';
import { StackedIcon } from '@eti/components';
import { Heading, Text, Stack, Inline, Card, breakpoints } from '@etg/wings';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const headerStyles = css`
  display: flex;
  height: 3.875rem;
`;
const descriptionStyles = css`
  font-size: 0.875rem;
  margin-bottom: 1rem;
  text-align: center;
`;
const iconStyles = css`
  flex: 1;
  margin: 0 2px;
  max-height: 33px;
  max-width: 30px;
`;
const cardStyles = css`
  padding: 24px;
  width: 100%;

  @media (min-width: ${breakpoints._768}) {
    max-width: ${SEAT_MAP_CARD_MAX_WIDTH}px;
  }
`;
const SegmentPanel = ({
  title,
  content,
  icons,
  children
}) => {
  return /*#__PURE__*/_jsx(Stack, {
    align: "center",
    children: /*#__PURE__*/_jsxs(Card, {
      className: cardStyles,
      children: [/*#__PURE__*/_jsx(Inline, {
        align: "center",
        className: headerStyles,
        children: icons.map((stackedIcons, index) => /*#__PURE__*/_jsx(StackedIcon, {
          className: iconStyles,
          icons: stackedIcons
        }, `stacked-icon-${index}`))
      }), /*#__PURE__*/_jsxs(Stack, {
        align: "center",
        spacing: 8,
        children: [/*#__PURE__*/_jsx(Heading, {
          level: 3,
          children: title
        }), /*#__PURE__*/_jsx(Text, {
          className: descriptionStyles,
          children: content
        }), children]
      })]
    })
  });
};
export default SegmentPanel;
//# sourceMappingURL=SegmentPanel.js.map